
import gql from 'graphql-tag'

export const NOTIFICATIONS_QUERY = gql`
  query Notifications($persona: String!) {
    announcements(persona: $persona) {
      id
      title
      body
      link
      viewed
      createdAt
      updatedAt
    }
  }
`
export const MARK_NOTIFICATION_VIEWED = gql`
  mutation markNotificationViewed($announcementId: Int!) {
    markAnnouncementViewed(announcementId: $announcementId) {
      status
      errors
    }
  }
`
